import React from 'react';
import MobileRowStructure from './MobileRowStructure';
import MobileRowContent from './MobileRowContent';

interface MobileRowProps<T> {
  data: T;
  mainContent: (data: T) => React.ReactNode;
  expandableContent?: (data: T) => React.ReactNode;
  hasExpandableContent?: boolean;
}

const renderNullContent = () => null;

const MobileRow = <T extends { Id: number }>({
  data,
  mainContent,
  expandableContent,
  hasExpandableContent = true,
}: MobileRowProps<T>) => (
  <MobileRowStructure
    mainContent={
      <MobileRowContent
        data={data}
        mainContent={mainContent}
        expandableContent={expandableContent}
        hasExpandableContent={hasExpandableContent}
      />
    }
    expandableContent={
      hasExpandableContent && expandableContent ? (
        <MobileRowContent
          data={data}
          mainContent={renderNullContent}
          expandableContent={expandableContent}
          hasExpandableContent={false}
        />
      ) : undefined
    }
    hasExpandableContent={hasExpandableContent}
  />
);

export default MobileRow;
